import { useParams } from "react-router";
import { DocumentationCard } from "@/services/backend/rlt/work-orders/components/documentation-card";
import { useRltWorkOrderShowQuery } from "@/services/backend/rlt/work-orders/api/work-order-api";

export function WorkOrderCompletionDocumentationRoute() {
  const { workOrderId, documentationId } = useParams();
  const { data: workOrder } = useRltWorkOrderShowQuery({ id: workOrderId! });
  return (
    <DocumentationCard
      documentationId={documentationId!}
      workOrderId={workOrderId!}
      disabled={workOrder?.immutable ?? false}
    />
  );
}
